import { PartType } from '../constants/part-type.js';
import { isStockablePartType } from './is-stockable-part-type.js';
/**
 * Every part type that is not stockable — the types that can be booked as a cost rather than
 * picked as material.
 *
 * Derived from `isStockablePartType` rather than listed, because that predicate is what
 * `addWorkOrderCharge` refuses on: a hand-written complement drifted the moment a seventh
 * `PartType` appeared, leaving the server admitting a type the charge picker never offered.
 */
export const NON_STOCKABLE_PART_TYPE_IDS = Object.values(PartType)
    .filter((value) => typeof value === 'number')
    .filter((typeId) => !isStockablePartType(typeId));
//# sourceMappingURL=non-stockable-part-type-ids.js.map